import script from "./TournamentHowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentHowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./TournamentHowItWorks.vue?vue&type=style&index=0&id=7a476d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a476d6e"]])

export default __exports__